import options from './radio-status.component';

export default {
    selector: 'dtRadioStatus',
    options
};



// WEBPACK FOOTER //
// ./app/common/radio-status/index.js